// material-ui
import {} from '@mui/material'
import React from 'react'
import { useParams } from 'react-router-dom'

import { Button, Grid, Stack } from '@mui/material'
import TitleService from 'title-service'
import MainCard from 'ui-component/cards/MainCard'
import AnimateButton from 'ui-component/extended/AnimateButton'

import { gridSpacing } from 'store/constant'

// assets
import * as autoThunks from 'features/auto-thunks'
import { useEffect } from 'react'

import Busy from 'components/Busy'
import ContentHouseForm from 'components/ContentHouseForm'
import { getUserClaims } from 'features/application/application-slice'
import { get_selected_contentHouse } from 'features/contentHouse/contentHouse-slice'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid
  const params = useParams()
  let dispatch = useDispatch()
  let claims = useSelector(getUserClaims)
  let contentHouse = useSelector(get_selected_contentHouse)
  const [valid, setValid] = React.useState(null)
  const [dirty, setDirty] = React.useState(null)
  const [formChanges, setFormChanges] = React.useState(null)
  const [updateArgs, setUpdateArgs] = React.useState(null)

  useEffect(() => {
    if (claims?.user && params?.id) {
      dispatch(autoThunks.load_my_content_houses({ fire_user: claims?.user }))
    }
  }, [claims?.user, params?.id])
  useEffect(() => {
    if (claims?.contentCreator && updateArgs?.id) {
      dispatch(
        autoThunks.update_contenthouse_information({
          fire_user: (() => {
            function get_userId(): any {
              return claims.user
            }
            return get_userId()
          })(),
          update: (() => {
            function _get_current(): any {
              return updateArgs
            }
            return _get_current()
          })(),
        }),
      )
    }
  }, [claims?.contentCreator, updateArgs])

  function createContentCreatorForm(submit: any): any {
    return (
      <>
        <ContentHouseForm
          page={undefined}
          context={{
            contentHouseProfileImage: {
              image: true,
              title: TitleService('Content House Profile Image'),
              componentTitle: TitleService('Content House Image'),
              storageLocation: `images/${claims?.contentCreator}/ContentHouse_ProfileImages`,
            },
          }}
          onUpdate={(form, valid, dirty) => {
            setValid(valid)
            setDirty(dirty)
            setFormChanges(form)
          }}
          form={{ ...contentHouse, ...formChanges }}
        />
        <Grid item xs={12}>
          <Stack direction="row" justifyContent="flex-end">
            <AnimateButton>
              <Button
                variant="contained"
                disabled={!valid}
                onClick={async () => {
                  setUpdateArgs({
                    ...contentHouse,
                    ...formChanges,
                  })
                  setFormChanges({})
                  setValid(false)
                  setDirty(false)
                }}
              >
                {TitleService('Verify & Submit')}
              </Button>
            </AnimateButton>
          </Stack>
        </Grid>
      </>
    )
  }

  let output_createContentCreatorForm = createContentCreatorForm(null)

  function get_me(form: any): any {
    return (
      <MainCard title={TitleService('Us')}>
        <Busy />
        <Grid container spacing={gridSpacing}>
          {form}
        </Grid>
      </MainCard>
    )
  }

  let output_get_me = get_me(output_createContentCreatorForm)

  return output_get_me
}
